import { render } from "./LocationPanel.vue?vue&type=template&id=b6bf5148"
import script from "./LocationPanel.vue?vue&type=script&lang=js"
export * from "./LocationPanel.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__